import script from "./Call-For-FS-Closed.vue?vue&type=script&setup=true&lang=js"
export * from "./Call-For-FS-Closed.vue?vue&type=script&setup=true&lang=js"

import "./Call-For-FS-Closed.vue?vue&type=style&index=0&id=471a7abc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471a7abc"]])

export default __exports__